<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card class="pa-5" v-if="!loadingData">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn(setRole)"
          @submit.prevent
        >
        <!-- eslint-disable -->
        <div style="position: relative" class="mb-4">
              <v-radio-group
                v-model="setRole"
                class="colored-options"
                data-testid="choose-role-options"
              >
                <div style="position:relative" class="mb-4">
                  <v-radio
                    key="participant"
                    value="participant"
                    color="accent"
                    :disabled="leftSpaceMembers == 0"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-participant"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{ $t("chooseRoleSpaceMemberOptionTitle") }}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleSpaceMemberOptionText") }}</span><br />
                        <span
                          v-if="leftSpaceMembers > 0 && setRole == 'participant'"
                          class="text-subtitle-2 success--text font-weight-regular">
                          {{ $tc("chooseRoleSpaceMemberOptionTextSecond",leftSpaceMembers,{ numberPeople: leftSpaceMembers })}}</span>
                        <span v-if="leftSpaceMembers == 0 && setRole == 'participant'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleSpaceMemberOptionTextSecondError")}}</span>   
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>
                    <v-overlay
                      v-if="leftSpaceMembers < 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreSpaceMembers") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                  </v-fade-transition>
                </div>
                <div style="position:relative" class="mb-4">
                  <v-radio
                    key="booster"
                    value="booster"
                    color="accent"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-booster"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{ $t("chooseRoleBoosterOptionTitle") }}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleBoosterOptionText") }}</span><br />
                        <span v-if="leftBoosters > 0 && setRole == 'booster'"
                              class="text-subtitle-2 success--text font-weight-regular">
                              {{ $tc("chooseRoleBoosterOptionTextSecond",leftBoosters,{ numberPeople: leftBoosters }) }}</span>
                        <div v-if="page == 'space-members' || page == 'invites'">
                        <span v-if="leftBoosters <= 0 && setRole == 'booster'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleBoosterOptionTextSecondError")}}</span>     
                        </div>
                      <div v-else>
                        <span v-if="leftBoosters < 0 && setRole == 'booster'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleBoosterOptionTextSecondError")}}</span>  
                      </div>
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>
                   <div v-if="page == 'space-members' || page == 'invites'">
                    <v-overlay
                      v-if="leftBoosters <= 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreBoosters") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                    </div>
                    <div v-else>
                       <v-overlay
                      v-if="leftBoosters < 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreBoosters") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                    </div>
                  </v-fade-transition>
                </div>
                <div style="position:relative" class="mb-4">
                  <v-radio
                    v-if="role == 'space_admin'"
                    key="space_admin"
                    value="space_admin"
                    color="accent"
                    class="black--text pa-5 option rounded-xxl mb-0"
                    data-testid="choose-role-space-admin"
                    active-class="selected"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text-subtitle-1 font-weight-bold">{{  $t("chooseRoleSpaceAdminOptionTitle") }}</span><br />
                        <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("chooseRoleSpaceAdminOptionText") }}</span><br />
                        <span v-if="leftBoosters > 0 && setRole == 'space_admin'"
                              class="text-subtitle-2 success--text font-weight-regular">
                              {{ $tc("chooseRoleSpaceAdminOptionTextSecond",leftBoosters,{ numberPeople: leftBoosters })}}</span>
                        <div v-if="page == 'space-members' || page == 'invites'">
                        <span v-if="leftBoosters <= 0 && setRole == 'space_admin'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleSpaceAdminOptionTextSecondError")}}</span>     
                        </div>
                      <div v-else>
                        <span v-if="leftBoosters < 0 && setRole == 'space_admin'"
                        class="text-subtitle-2 error--text font-weight-regular">
                        {{$tc("chooseRoleSpaceAdminOptionTextSecondError")}}</span>  
                      </div>
                      </div>
                    </template>
                  </v-radio>
                  <v-fade-transition>

                    <div v-if="page == 'space-members' || page == 'invites'">
                    <v-overlay
                      v-if="leftBoosters <= 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreSpaceAdmins") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                    </div>
                    <div v-else>
                       <v-overlay
                      v-if="leftBoosters < 0"
                      absolute
                      class="rounded-xxl"
                      color="white"
                    >
                      <v-btn
                        v-if="productPlan.attributes.name == 'Pro'"
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("addMoreSpaceAdmins") }}</v-btn
                      >
                      <v-btn
                        v-else
                        ref="create"
                        data-testid="button"
                        color="accent"
                        min-width="100"
                        dark
                        elevation="0"
                        class="rounded-xxl text-none px-4"
                        @click="proceedSubmit"
                        >{{ $t("upgradePlan") }}</v-btn
                      >
                    </v-overlay>
                    </div>
                  </v-fade-transition>
                </div>
              </v-radio-group>
              <v-fade-transition>
                <v-overlay
                  v-if="leftSpaceMembers == 0 && leftBoosters == 0"
                  absolute
                  class="rounded-xxl"
                  color="white"
                >
                  <v-btn
                    ref="create"
                    data-testid="button"
                    color="accent"
                    min-width="100"
                    dark
                    elevation="0"
                    class="rounded-xxl text-none px-4"
                    @click="proceedSubmit"
                    >{{ $t("upgradePlan") }}</v-btn
                  >
                </v-overlay>
              </v-fade-transition>
            </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          elevation="0"
          :class="!disabled?'rounded-xxl text-none px-4 disabled-submit':'rounded-xxl text-none px-4 submit'"
          :loading="loading"
          :disabled="(leftSpaceMembers <= 0 && setRole=='participant') || (leftBoosters < 0 && (setRole=='booster' || setRole=='space_admin'))"
          @click="submitDialogBtn(setRole)"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';
import { getSpaceUsersStatistics } from "../api/spaceApi";

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedRole:{
      type: String,
      default:'participant'
    },
    page: {
      type: String,
      default: ''
    }
  },
  data(){
      return{
        disabled:false,
        valid: true,
        alertMsg: '',
        alertType:'',
        alertValue:'',
        check: false,
        spaceId: window.$cookies.get("space_id"),
        role: localStorage.space ? JSON.parse(localStorage.space).role : '',
        setRole: this.selectedRole,
        boosters: 0,
        boosters_allowed: 0,
        spaceAdmins: 0,
        spaceMembers: 0,
        statistics: {},
        leftBoosters: 0,
        leftSpaceMembers: 0,
        statisticsBoosters: 0,
        statisticsSpaceMembers: 0,
        loadingData:false
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                    this.$refs.form.reset()
                }
            }
        },
        productPlan() {
          return this.$store.state.productPlan;
        },
    },
    async created() {
        if(this.setRole == null){
          // eslint-disable-next-line
          this.setRole = 'participant'
        }
        await this.getSubscriptionStatistics();
    },
    methods: {
      proceedSubmit() {
        this.$router.push({path: '/space/subscription'})
      },
      submitDialogBtn(setRole) {
        this.valid = this.$refs.form.validate()
        if(this.valid){
          this.$emit('proceedSubmit',setRole)
        }
      },
      async getSubscriptionStatistics() {
        this.loadingData =true
        try {
          const response = await getSpaceUsersStatistics(this.spaceId);
          if (response.status == 200) {
            this.statistics = response.data.meta;
            this.statisticsBoosters = this.statistics.booster_count + this.statistics.booster_invites + this.statistics.admin_invites;
            this.statisticsSpaceMembers = this.statistics.total_members_count + this.statistics.total_invites;
            this.boosters_allowed = this.statistics.boosters_allowed;
            this.spaceMembers = this.statistics.space_members_allowed;
            this.leftBoosters = this.statistics.boosters_allowed - this.statisticsBoosters;
            this.leftSpaceMembers = this.statistics.total_allowed - this.statisticsSpaceMembers;
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertValue = true;
            this.alertMsg = i18n.t("serverError");
          }
        }
        this.loadingData = false
    },
  },
}
</script>